import { ComponentStyleConfig } from "@chakra-ui/react";

export const ButtonTheme: ComponentStyleConfig = {
  baseStyle: (props) => {
    // Get the original background color from props
    const bg = props.bg || props.background || props.bgColor;

    return {
      _disabled: {
        opacity: 0.6,
        cursor: "not-allowed",
        pointerEvents: "none",
        // Preserve the button's original background color
        ...(bg && { background: bg }),
        _hover: {
          opacity: 0.6,
          // Preserve background on hover when disabled
          ...(bg && { background: bg }),
        },
        _active: {
          opacity: 0.6,
          // Preserve background on active when disabled
          ...(bg && { background: bg }),
        },
        _focus: {
          opacity: 0.6,
          // Preserve background on focus when disabled
          ...(bg && { background: bg }),
        },
      },
      _loading: {
        opacity: 1, // Keep full opacity when loading (spinner should be visible)
        cursor: "wait",
        pointerEvents: "none",
        // Preserve the button's original background color
        ...(bg && { background: bg }),
      },
    };
  },
  sizes: {
    md: {
      h: "55px",
      w: "190px",
      fontSize: "16px",
      fontWeight: "700",
    },
    sm: {
      h: "36px",
      w: "auto",
      px: "24px",
      fontSize: "12px",
      fontWeight: "500",
    },
    full: {
      h: "55px",
      w: "100%",
      fontSize: "16px",
    },
  },
  variants: {
    primary: {
      bg: "primary.200",
      color: "white.100",
      borderRadius: "12px",
    },
  },
  defaultProps: {
    size: "md",
    variant: "primary",
  },
};
